export const res = {
  title: {
    is: 'Nánar um auðkenningarleiðir',
    en: 'More about authentication methods',
    pl: 'Więcej o sposobach identyfikacji',
  } as const,
  link: {
    is: 'https://www.landsbankinn.is/audkenningarleidir',
    en: 'https://www.landsbankinn.is/en/authentication-methods',
    pl: 'https://www.landsbankinn.is/pl/metody-identyfikacji',
  } as const,
};
